import { Auth } from 'aws-amplify';
import cognitoAuth from '../../services/cognito/cognito-service';
import profileContent from '../../services/api/profile/profile-content';

const state = {
  cognitoInfo: {},
  loggedIn: false,
  loading: false,
  userImage: undefined,
  userRoles: [],
};

const getters = {
  cognitoInfo: state => state.cognitoInfo,
  skus: state => {
    if (!state.cognitoInfo || !state.cognitoInfo.sku) {
      return [];
    }
    const skus = state.cognitoInfo.sku ? state.cognitoInfo.sku.split(',') : [];
    return skus.map(sku => sku.trim());
  },
  loggedIn: state => state.loggedIn,
  loading: state => state.loading,
  userImage: state => state.userImage,
  canCustomizeContent: state => state.userRoles.includes('canCustomizeContent'),
  isTrial: state => state.userRoles.includes('isTrial'),
  hasBoosters: state => state.userRoles.includes('hasBoosters'),
  hasOCN: state => state.userRoles.includes('hasOCN'),
};

const mutations = {
  setLoggedIn(state, newValue) {
    state.loggedIn = newValue;
  },
  setLoggedOut(state) {
    state.loggedIn = false;
    state.cognitoInfo = {};
  },
  setLoading(state, newValue) {
    state.loading = newValue;
  },
  setCognitoInfo(state, newValue) {
    state.cognitoInfo = newValue;
  },
  setUserImage(state, newValue) {
    state.userImage = newValue;
  },
  addUserRole(state, role) {
    if (!state.userRoles.includes(role)) {
      state.userRoles.push(role);
    }
  },
};

const actions = {
  getUserInfo({ state, commit }) {
    return new Promise(async(resolve) => {
      if (Object.entries(state.cognitoInfo).length === 0) {
        commit('setLoggedIn', true);

        const currentSession = await Auth.currentSession();
        const cognitoInfo = currentSession.getIdToken().decodePayload();
        commit('setCognitoInfo', cognitoInfo);

        if (await cognitoAuth.canCustomizeContent()) {
          commit('addUserRole', 'canCustomizeContent');
        }
        if (await cognitoAuth.isTrialUser()) {
          commit('addUserRole', 'isTrial');
        }
        if (await cognitoAuth.hasBoosters()) {
          commit('addUserRole', 'hasBoosters');
        }
        if (await cognitoAuth.hasOCN()) {
          commit('addUserRole', 'hasOCN');
        }
      }
      resolve(state.cognitoInfo);
    });
  },
  login({ commit }, loggedIn) {
    commit('setLoggedIn', loggedIn);
  },
  getUserImage({ state, commit }) {
    return new Promise(resolve => {
      if (state.userImage === undefined && !state.loading) {
        commit('setLoading', true);
        profileContent.getUserImage()
          .then(res => {
            commit('setUserImage', res);
            commit('setLoading', false);
            resolve(state.userImage);
          });
      } else {
        resolve(state.userImage);
      };
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
